import * as moment from 'moment';
import { Moment } from 'moment';
import Company from 'src/entities/Company';
import ProjectImage from 'src/entities/ProjectImage';
import ProjectDocument from 'src/entities/ProjectDocument';
import ProjectTeamMembers from 'src/value-objects/ProjectTeamMembers';
import Investment from 'src/entities/Investment';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import ProjectDocumentData from './ProjectDocumentData';

interface InitialData {
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export default class ProjectData {
  id: number;
  cashTarget: number;
  startDate: Moment;
  endDate: Moment;
  cash: number;
  capital: string;
  numberInvestors: number;
  company: Company;
  ticketValue: number;
  premoneyValuation: number;
  coInvestorsInvest: number;
  equity: number;
  sharePercentage: number;
  interested: number;
  description: string;
  images: ProjectImage[];
  offlineInvestors: OfflineInvestor[];
  metrics: string;
  goToMarketDescription: string;
  goToMarketImage?: ProjectImage;
  syndicateAgreement?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  syndicateAgreementImage?: ProjectImage;
  stakeholderAgreement?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  stakeholderAgreementImage?: ProjectImage;
  roundDetails: string;
  highlightInvestorName?: string;
  highlightInvestorDescription?: string;
  highlightInvestorImage?: ProjectImage;
  environmentDescription: string;
  environmentImage?: ProjectImage;
  documents: ProjectDocument[];
  teamMembers: ProjectTeamMembers[];
  invested: Investment[];
  status?: string;
  marketData?: string;
  dueDiligenceReport?: string;

  constructor(entity: InitialData) {
    this.id = entity.id;
    this.cashTarget = entity.cashTarget;
    this.startDate = moment.utc(entity.startDate);
    this.endDate = moment.utc(entity.endDate);
    this.cash = entity.cash;
    this.capital = entity.capital;
    this.numberInvestors = entity.numberInvestors;
    this.company = new Company(entity.company);
    this.ticketValue = entity.ticketValue;
    this.premoneyValuation = entity.premoneyValuation;
    this.coInvestorsInvest = entity.coInvestorsInvest;
    this.equity = entity.equity;
    this.sharePercentage = entity.sharePercentage;
    this.interested = entity.interested;
    this.description = entity.description;
    this.images = entity.images.map((image: ProjectImage) => new ProjectImage(image));
    this.offlineInvestors = entity
      .offlineInvestors
      .map((offlineInvestor: OfflineInvestor) => new OfflineInvestor(offlineInvestor));
    this.description = entity.description;
    this.metrics = entity.metrics;
    this.goToMarketDescription = entity.goToMarketDescription;
    this.goToMarketImage = entity.goToMarketImage ? new ProjectImage(entity.goToMarketImage) : undefined;
    this.syndicateAgreement = typeof entity.syndicateAgreement === 'object' ?
      entity.syndicateAgreement :
      { url: entity.syndicateAgreement };
    this.syndicateAgreementImage = entity.syndicateAgreementImage ?
      new ProjectImage(entity.syndicateAgreementImage) : undefined;
    this.stakeholderAgreement = typeof entity.stakeholderAgreement === 'object' ?
    entity.stakeholderAgreement :
    { url: entity.stakeholderAgreement };
    this.stakeholderAgreementImage = entity.stakeholderAgreementImage ?
      new ProjectImage(entity.stakeholderAgreementImage) : undefined;
    this.roundDetails = entity.roundDetails;
    this.highlightInvestorName = entity.highlightInvestorName || undefined;
    this.highlightInvestorDescription = entity.highlightInvestorDescription || undefined;
    this.highlightInvestorImage = entity.highlightInvestorImage ?
      new ProjectImage(entity.highlightInvestorImage) : undefined;
    this.environmentDescription = entity.environmentDescription;
    this.environmentImage = entity.environmentImage ? new ProjectImage(entity.environmentImage) : undefined;
    this.documents = entity.documents.map((document: ProjectDocumentData) => new ProjectDocumentData(document));
    this.teamMembers = entity.teamMembers.map((teamMember: ProjectTeamMembers) => new ProjectTeamMembers(teamMember));
    this.invested = entity.invested ?
      entity.invested.map((investment: Investment) => new Investment(investment)) :
      [];
    this.status = entity.status;
    this.marketData = entity.marketData || '';
    this.dueDiligenceReport = entity.dueDiligenceReport;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/ProjectData.tsx